"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[806],{

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FallBackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const FallBackImage = (param)=>{
    let { src , alt , ...rest } = param;
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(src);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setImgSrc(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...rest,
        alt: alt,
        fill: true,
        src: imgSrc ? imgSrc : "/img/no-image.jpeg",
        onError: ()=>{
            setImgSrc("/img/no-image.jpeg");
        }
    });
};


/***/ }),

/***/ 5460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SingleBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function SingleBanner(param) {
    let { imageUrl  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: imageUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "dealership-hero position-relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dl-hero-single",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "at_hero_slider",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "at-hero-banner",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: imageUrl,
                            alt: "banner",
                            width: 1440,
                            height: 350,
                            sizes: "100vw",
                            style: {
                                width: "100%",
                                height: "auto",
                                objectFit: "cover"
                            }
                        })
                    })
                })
            })
        }) : null
    });
}


/***/ }),

/***/ 9963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StockInventoryListing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _default_fallback_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2908);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1358);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_paginate__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8382);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7333);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1173);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3680);
/* harmony import */ var react_custom_scrollbars__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1298);









function StockInventoryListing(param) {
    let { ads , pageSize , models  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const pageCount = Math.ceil(ads.paginationOut.totalRows / pageSize);
    const [showFilterModal, setShowFilterModal] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        isOpen: false
    });
    const [showMore, setShowMore] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        brands: false,
        models: false,
        yearsModel: false,
        transmissions: false,
        fuels: false
    });
    const [filters, setFilters] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        isLoading: true,
        brands: [],
        models: [],
        yearsModel: [],
        transmissions: [],
        fuels: []
    });
    const handlePageClick = (event)=>{
        $(".ring-preloader").fadeIn();
        router.query.pag = event.selected;
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handleFilterCheckboxClick = (event, value, type)=>{
        delete router.query["filter"];
        if (event.target.checked) {
            if (router.query[type]) router.query[type] = router.query[type] + "|".concat(value);
            else router.query[type] = value;
        } else {
            if (router.query[type].indexOf("|") >= 0) {
                const splitStr = router.query[type].split("|");
                router.query[type] = splitStr.filter((item)=>item !== value).join("|");
            } else delete router.query[type];
        }
        delete router.query.pag;
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handleOrderChange = (event)=>{
        $(".ring-preloader").fadeIn();
        router.query.ordem = event.target.value;
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handleGridTypeClick = ()=>{
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = "grid";
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handleListTypeClick = ()=>{
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = "list";
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handlePriceFromChange = (event)=>{
        delete router.query["filter"];
        if (event.target.value) router.query.preco_de = event.target.value;
        else delete router.query["preco_de"];
        delete router.query.pag;
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const handlePriceToChange = (event)=>{
        delete router.query["filter"];
        if (event.target.value) router.query.preco_ate = event.target.value;
        else delete router.query["preco_ate"];
        delete router.query.pag;
        router.push("".concat(router.pathname, "?").concat(new URLSearchParams(router.query)));
    };
    const FilterComponent = (param)=>{
        let { isFromMobile  } = param;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: !isFromMobile ? "sidebar-widget bg-white rounded" : "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "iv_listing",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "iv_listing_top rounded",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "iv_listing_filter_menu",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-solid fa-filter"
                                        }),
                                        "\xa0\xa0\xa0FILTRE SUA BUSCA"
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "spacer mb-3"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "PRE\xc7O"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "ml-10 mr-30 mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                className: "form-select",
                                                onChange: handlePriceFromChange,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "",
                                                        children: "Pre\xe7o De:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "10000",
                                                        children: "R$ 10.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "20000",
                                                        children: "R$ 20.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "30000",
                                                        children: "R$ 30.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "40000",
                                                        children: "R$ 40.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "50000",
                                                        children: "R$ 50.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "60000",
                                                        children: "R$ 60.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "70000",
                                                        children: "R$ 70.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "80000",
                                                        children: "R$ 80.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "90000",
                                                        children: "R$90.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "100000",
                                                        children: "R$ 100.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "200000",
                                                        children: "R$ 200.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "300000",
                                                        children: "R$ 300.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "400000",
                                                        children: "R$ 400.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "500000",
                                                        children: "R$ 500.000,00"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                className: "form-select",
                                                onChange: handlePriceToChange,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "",
                                                        children: "Pre\xe7o At\xe9:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "10000",
                                                        children: "R$ 10.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "20000",
                                                        children: "R$ 20.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "30000",
                                                        children: "R$ 30.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "40000",
                                                        children: "R$ 40.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "50000",
                                                        children: "R$ 50.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "60000",
                                                        children: "R$ 60.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "70000",
                                                        children: "R$ 70.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "80000",
                                                        children: "R$ 80.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "90000",
                                                        children: "R$90.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "100000",
                                                        children: "R$ 100.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "200000",
                                                        children: "R$ 200.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "300000",
                                                        children: "R$ 300.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "400000",
                                                        children: "R$ 400.000,00"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                        value: "500000",
                                                        children: "R$ 500.000,00"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: "spacer mt-3 mb-3"
                        })
                    ]
                }),
                filters.brands.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            style: filters.brands.length > 7 && !showMore.brands ? {
                                height: "200px",
                                overflow: "hidden"
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "MARCA"
                                }),
                                filters.brands.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-10 mr-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "label-form",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    className: "chck-form",
                                                    type: "checkbox",
                                                    defaultChecked: router.query.marca ? router.query.marca.split("|").includes(item.name) : false,
                                                    onClick: (e)=>{
                                                        handleFilterCheckboxClick(e, item.name, "marca");
                                                    }
                                                }),
                                                item.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    style: {
                                                        marginLeft: "2px"
                                                    },
                                                    children: "(".concat(item.quantity, ")")
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        filters.brands.length > 7 ? !showMore.brands ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    brands: true
                                });
                            },
                            children: "ver mais..."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    brands: false
                                });
                            },
                            children: "ver menos..."
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: "spacer mt-3 mb-3"
                        })
                    ]
                }) : null,
                models.models.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            style: filters.models.length > 7 && !showMore.models ? {
                                height: "200px",
                                overflow: "hidden"
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "MODELO"
                                }),
                                filters.models.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-10 mr-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "label-form",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    type: "checkbox",
                                                    defaultChecked: router.query.modelo ? router.query.modelo.split("|").includes(item.name) : false,
                                                    onClick: (e)=>{
                                                        handleFilterCheckboxClick(e, item.name, "modelo");
                                                    }
                                                }),
                                                item.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    style: {
                                                        marginLeft: "2px"
                                                    },
                                                    children: "(".concat(item.quantity, ")")
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        filters.models.length > 7 ? !showMore.models ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    models: true
                                });
                            },
                            children: "ver mais..."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    models: false
                                });
                            },
                            children: "ver menos..."
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: "spacer mt-3 mb-3"
                        })
                    ]
                }) : null,
                filters.yearsModel.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            style: filters.yearsModel.length > 7 && !showMore.yearsModel ? {
                                height: "200px",
                                overflow: "hidden"
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "ANO MODELO"
                                }),
                                filters.yearsModel.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-10 mr-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "label-form",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    type: "checkbox",
                                                    defaultChecked: router.query.ano ? router.query.ano.split("|").includes(item.name) : false,
                                                    onClick: (e)=>{
                                                        handleFilterCheckboxClick(e, item.name, "ano");
                                                    }
                                                }),
                                                item.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    style: {
                                                        marginLeft: "2px"
                                                    },
                                                    children: "(".concat(item.quantity, ")")
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        filters.yearsModel.length > 7 ? !showMore.yearsModel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    yearsModel: true
                                });
                            },
                            children: "ver mais..."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "a-style1 ml-20",
                            href: "#",
                            onClick: ()=>{
                                setShowMore({
                                    ...showMore,
                                    yearsModel: false
                                });
                            },
                            children: "ver menos..."
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: "spacer mt-3 mb-3"
                        })
                    ]
                }) : null,
                filters.transmissions.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "C\xc2MBIO"
                                }),
                                filters.transmissions.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-10 mr-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "label-form",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    type: "checkbox",
                                                    defaultChecked: router.query.cambio ? router.query.cambio.split("|").includes(item.name) : false,
                                                    onClick: (e)=>{
                                                        handleFilterCheckboxClick(e, item.name, "cambio");
                                                    }
                                                }),
                                                item.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    style: {
                                                        marginLeft: "2px"
                                                    },
                                                    children: "(".concat(item.quantity, ")")
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                            className: "spacer mt-3 mb-3"
                        })
                    ]
                }) : null,
                filters.fuels.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-20",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        fontWeight: "bolder"
                                    },
                                    children: "COMBUST\xcdVEL"
                                }),
                                filters.fuels.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-10 mr-10",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "label-form",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    type: "checkbox",
                                                    defaultChecked: router.query.combustivel ? router.query.combustivel.split("|").includes(item.name) : false,
                                                    onClick: (e)=>{
                                                        handleFilterCheckboxClick(e, item.name, "combustivel");
                                                    }
                                                }),
                                                item.name,
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("sup", {
                                                    style: {
                                                        marginLeft: "2px"
                                                    },
                                                    children: "(".concat(item.quantity, ")")
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                height: "20px"
                            }
                        })
                    ]
                }) : null
            ]
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (filters.isLoading) {
            (0,_services_api__WEBPACK_IMPORTED_MODULE_5__/* .fetchGetAdsFilters */ .zn)({
                condition: router.pathname === "/novos" ? "NEW" : router.pathname === "/seminovos" ? "USED" : ""
            }).then((res)=>{
                if (res) {
                    setFilters({
                        isLoading: false,
                        ...res
                    });
                }
            }).catch(()=>{
                setFilters({
                    ...filters,
                    isLoading: false
                });
            });
        } else if (!filters.isLoading) $(".at_scrollbar").mCustomScrollbar({
            axis: "y"
        });
    }, [
        filters,
        router.pathname
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        $(".ring-preloader").fadeOut();
    }, [
        ads
    ]);
    var _price, _mileage, _mileage1, _price1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "inventory-details-area ptb-40",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            xl: 3,
                            lg: 4,
                            md: 3,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterComponent, {
                                isFromMobile: false
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            xl: 9,
                            lg: 8,
                            md: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "iv_listing mt-xl-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "iv_listing_top d-flex flex-wrap align-items-center bg-white justify-content-end rounded mb-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "iv_listing_filter_menu d-flex flex-wrap align-items-center justify-content-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                    className: "form-select fw-500",
                                                    onChange: handleOrderChange,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "BRAND_AND_MODEL",
                                                            children: "Marca e Modelo"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "LOWEST_PRICE",
                                                            children: "Menor Pre\xe7o"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "BIGGEST_PRICE",
                                                            children: "Maior Pre\xe7o"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "NEWER_VEHICLES",
                                                            children: "Mais Novos"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#",
                                                    className: "grid_btn ".concat(!router.query.tipo_lista || router.query.tipo_lista === "grid" ? "active" : ""),
                                                    onClick: handleGridTypeClick,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "flaticon-menu-1"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#",
                                                    className: "grid_btn ".concat(router.query.tipo_lista && router.query.tipo_lista === "list" ? "active" : ""),
                                                    onClick: handleListTypeClick,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "flaticon-list-interface-symbol"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#",
                                                    className: "grid_btn2",
                                                    onClick: ()=>{
                                                        setShowFilterModal({
                                                            ...showFilterModal,
                                                            isOpen: true
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "fa-solid fa-magnifying-glass"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mb-0 fw-500 d-inline-block",
                                            style: {
                                                fontSize: "14px"
                                            },
                                            children: "".concat(ads.paginationOut.totalRows, " ofertas encontradas")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row g-4 justify-content-center",
                                        children: ads.items.length > 0 ? ads.items.map((item, index)=>!router.query.tipo_lista || router.query.tipo_lista === "grid" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "filter-card-item position-relative overflow-hidden rounded bg-white",
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: ()=>{
                                                        window.location = "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "feature-thumb position-relative overflow-hidden",
                                                            style: {
                                                                position: "relative",
                                                                width: "100%",
                                                                maxWidth: "430px",
                                                                aspectRatio: "70/65"
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_default_fallback_image__WEBPACK_IMPORTED_MODULE_1__/* .FallBackImage */ .A, {
                                                                    className: "img-card-fluid",
                                                                    priority: true,
                                                                    alt: "".concat(item.brand, " ").concat(item.model),
                                                                    src: item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "filter-card-content",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "price-btn text-end position-relative",
                                                                    children: [
                                                                        item.promotionalPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "price",
                                                                            children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                className: "small-btn-meta",
                                                                                style: {
                                                                                    color: "white",
                                                                                    fontSize: "14px",
                                                                                    textDecoration: "line-through"
                                                                                },
                                                                                value: (_price = item.price) !== null && _price !== void 0 ? _price : 0,
                                                                                displayType: "text",
                                                                                thousandSeparator: ".",
                                                                                decimalSeparator: ",",
                                                                                decimalScale: 2,
                                                                                fixedDecimalScale: true,
                                                                                prefix: "De R$ "
                                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "small-btn-meta",
                                                                                children: "Consulte-nos"
                                                                            })
                                                                        }) : null,
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                            className: "price",
                                                                            children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                className: "small-btn-meta",
                                                                                style: {
                                                                                    fontSize: "16px"
                                                                                },
                                                                                value: item.promotionalPrice ? item.promotionalPrice : item.price,
                                                                                displayType: "text",
                                                                                thousandSeparator: ".",
                                                                                decimalSeparator: ",",
                                                                                decimalScale: 2,
                                                                                fixedDecimalScale: true,
                                                                                prefix: "".concat(item.promotionalPrice ? "Por R$ " : "R$ ")
                                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "small-btn-meta",
                                                                                children: "Consulte-nos"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id),
                                                                    className: "mt-2 d-block",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "h5",
                                                                        children: "".concat(item.brand, " ").concat(item.model)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "meta-content",
                                                                    style: {
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        display: "inline-block",
                                                                        width: "100%"
                                                                    },
                                                                    children: item.version
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                                    className: "spacer mt-3 mb-3"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "card-feature-box d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "icon-box d-flex align-items-center",
                                                                            title: item.transmission,
                                                                            style: {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                display: "inline-block",
                                                                                width: "100%"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "me-2",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                        className: "flaticon-steering-wheel"
                                                                                    })
                                                                                }),
                                                                                item.transmission
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "icon-box d-flex align-items-center",
                                                                            title: item.fuel,
                                                                            style: {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                display: "inline-block",
                                                                                width: "100%"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "me-2",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                        className: "flaticon-petrol"
                                                                                    })
                                                                                }),
                                                                                item.fuel
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "card-feature-box d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "icon-box d-flex align-items-center",
                                                                            title: item.transmission,
                                                                            style: {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                display: "inline-block",
                                                                                width: "100%"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "me-2",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                        className: "flaticon-calendar"
                                                                                    })
                                                                                }),
                                                                                item.yearModel
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "icon-box d-flex align-items-center",
                                                                            title: item.fuel,
                                                                            style: {
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                display: "inline-block",
                                                                                width: "100%"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "me-2",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                        className: "fa fa-gauge"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                    value: (_mileage = item.mileage) !== null && _mileage !== void 0 ? _mileage : 0,
                                                                                    displayType: "text",
                                                                                    thousandSeparator: ".",
                                                                                    decimalSeparator: ","
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "col-12",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "listing_card_item bg-white rounded overflow-hidden d-flex flex-row align-items-center position-relative",
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: ()=>{
                                                        window.location = "anuncio/".concat(item.category, "/").concat("".concat(item.brand.split(" ").join("-").toLowerCase(), "-").concat(item.model.split(" ").join("-").toLowerCase()), "/").concat(item.yearModel, "/").concat(item.id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "thumb-wrapper rounded-start",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "feature-thumb position-relative overflow-hidden",
                                                                style: {
                                                                    position: "relative",
                                                                    width: "200px",
                                                                    height: "200px",
                                                                    aspectRatio: "1/1"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_default_fallback_image__WEBPACK_IMPORTED_MODULE_1__/* .FallBackImage */ .A, {
                                                                    className: "img-card-fluid",
                                                                    alt: "".concat(item.brand, " ").concat(item.model),
                                                                    sizes: "30vw",
                                                                    loading: "lazy",
                                                                    src: item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "d-flex flex-column justify-content-between",
                                                            style: {
                                                                height: "200px",
                                                                width: "100%"
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "ml-20 mt-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "d-flex flex-row justify-content-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                    className: "mb-0",
                                                                                    children: "".concat(item.brand, " ").concat(item.model)
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "meta-text",
                                                                                    style: {
                                                                                        fontSize: "14px"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                                        className: "fw-semibold",
                                                                                        children: item.version
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "card-feature-box d-flex flex-wrap align-items-center mt-20",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "icon-box d-flex align-items-center border",
                                                                                            style: {
                                                                                                fontSize: "12px"
                                                                                            },
                                                                                            title: item.transmission,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "me-2",
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                                        className: "flaticon-steering-wheel"
                                                                                                    })
                                                                                                }),
                                                                                                item.transmission
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "icon-box d-flex align-items-center border",
                                                                                            style: {
                                                                                                fontSize: "12px"
                                                                                            },
                                                                                            title: item.fuel,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "me-2",
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                                        className: "flaticon-petrol"
                                                                                                    })
                                                                                                }),
                                                                                                item.fuel
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "icon-box d-flex align-items-center border",
                                                                                            style: {
                                                                                                fontSize: "12px"
                                                                                            },
                                                                                            title: item.yearModel,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "me-2",
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                                        className: "flaticon-calendar"
                                                                                                    })
                                                                                                }),
                                                                                                item.yearModel
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "icon-box d-flex align-items-center border",
                                                                                            style: {
                                                                                                fontSize: "12px"
                                                                                            },
                                                                                            title: item.mileage,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "me-2",
                                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                                        className: "fa fa-gauge"
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                                    value: (_mileage1 = item.mileage) !== null && _mileage1 !== void 0 ? _mileage1 : 0,
                                                                                                    displayType: "text",
                                                                                                    thousandSeparator: ".",
                                                                                                    decimalSeparator: ","
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "mr-20 d-flex flex-column align-items-end mt-1",
                                                                            children: [
                                                                                item.promotionalPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                    children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                        className: "small-btn-meta",
                                                                                        style: {
                                                                                            color: "white",
                                                                                            fontSize: "12px",
                                                                                            textDecoration: "line-through"
                                                                                        },
                                                                                        value: (_price1 = item.price) !== null && _price1 !== void 0 ? _price1 : 0,
                                                                                        displayType: "text",
                                                                                        thousandSeparator: ".",
                                                                                        decimalSeparator: ",",
                                                                                        decimalScale: 2,
                                                                                        fixedDecimalScale: true,
                                                                                        prefix: "De R$ "
                                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "small-btn-meta",
                                                                                        children: "Consulte-nos"
                                                                                    })
                                                                                }) : null,
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                                    children: item.price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, {
                                                                                        className: "small-btn-meta",
                                                                                        style: {
                                                                                            fontSize: "12px"
                                                                                        },
                                                                                        value: item.promotionalPrice ? item.promotionalPrice : item.price,
                                                                                        displayType: "text",
                                                                                        thousandSeparator: ".",
                                                                                        decimalSeparator: ",",
                                                                                        decimalScale: 2,
                                                                                        fixedDecimalScale: true,
                                                                                        prefix: "".concat(item.promotionalPrice ? "Por R$ " : "R$ ")
                                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        className: "small-btn-meta",
                                                                                        children: "Consulte-nos"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }, index)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: "nenhum registro encontrado..."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "template-pagination mt-5 pg-style-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_paginate__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            forcePage: router.query.pag ? parseInt(router.query.pag) : 0,
                                            className: "d-flex align-items-center justify-content-center",
                                            activeLinkClassName: "active",
                                            breakLabel: "...",
                                            nextLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-angles-right"
                                            }),
                                            onPageChange: handlePageClick,
                                            pageRangeDisplayed: 5,
                                            pageCount: pageCount,
                                            previousLabel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-angles-left"
                                            }),
                                            renderOnZeroPageCount: null
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showFilterModal.isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                show: showFilterModal.isOpen,
                backdrop: "static",
                keyboard: false,
                scrollable: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Body */ .Z.Body, {
                        className: "p-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterComponent, {
                            isFromMobile: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Footer */ .Z.Footer, {
                        style: {
                            position: "sticky",
                            bottom: "0px",
                            zIndex: "1055"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            variant: "secondary",
                            style: {
                                color: "white",
                                width: "100%"
                            },
                            onClick: ()=>{
                                setShowFilterModal({
                                    ...showFilterModal,
                                    isOpen: false
                                });
                            },
                            children: "Ver Resultado"
                        })
                    })
                ]
            }) : null
        ]
    });
}


/***/ })

}]);